import service from '@/utils/server';

const modName='/bd/weighRedFlush/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};


export const details = data => {
  return service({
    url: modName + 'details',
    method: 'post',
    data
  });
};


export const editInit = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};

export const submit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

export const initPurchOrder = data => {
  return service({
    url: modName + 'initPurchOrder',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/weighRedFlush/api/index.js